const generateArray = (count) => Array.from({ length: count }, (_, i) => i + 1);

export function Skeleton({ ...rest }) {
  return (
    <div
      {...rest}
      className="m-auto max-w-sm animate-pulse pt-0 sm:w-[250px] md:px-4"
    >
      <div className="mb-4 flex items-center justify-center rounded bg-gray-300 dark:bg-gray-700 sm:h-48  md:h-36 lg:h-36 xl:h-48"></div>
      <div className="mb-2.5 h-2 rounded-full bg-gray-200 dark:bg-gray-700"></div>
      <div className="mb-4 h-2.5 w-8 rounded-full bg-gray-200 dark:bg-gray-700"></div>
      <div className="mt-4 flex items-center space-x-3"></div>
    </div>
  );
}

export const generateSkeletons = (number) => {
  return generateArray(number).map((s, idx) => <Skeleton key={idx} />);
};
